import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';


const Body = ({ monthlyInventory, selectedDate, allAccess, selectedMonthText, selectedYear }) => {
    if(!monthlyInventory) return null;
    return (
    <div>
        { monthlyInventory.length <= 0 ?
            //     //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="text-center list_header">
                        {/* will be a dynamic date */}
                      {(selectedMonthText && selectedYear) && <p><i>Selected Date</i> <b>{`${selectedMonthText} ${selectedYear}`}</b></p>}
                    </div>

                    <div className="mt-2 pl-2 pr-2">
                        {
                            monthlyInventory.map((item, index) => {
                                return (
                                    <div className="row m-0 border_bottom_grey mb-1 pb-1 position-relative" key={index}>
                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                                            <div className="row m-0">
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 pl-2 pt-1 reduce-margin-top-report">
                                                    <label>Category</label>
                                                    <h4 className="m-0 font-weight-semibold">{item.categoryName}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9 m-0 p-0">
                                          <div className="row mb-3">
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                                              <label>Opening Inventory</label>
                                              <h3 className="m-0">{getDollarFormat(item.openInventory)}</h3>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  m-0 p-0">
                                              <label>Orders IN</label>
                                              <h3 className="m-0">{getDollarFormat(item.ordersIN)}</h3>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  m-0 p-0">
                                              <label>Adjustments IN</label>
                                              <h3 className="m-0">{getDollarFormat(item.adjustmentsIN)}</h3>
                                            </div>
                                          </div>
                                          <div className="row mb-3">
                                          <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                                              <label>Closing Inventory</label>
                                              <h3 className="m-0">{getDollarFormat(item.closingInventory)}</h3>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                                              <label>COGS</label>
                                              <h3 className="m-0">{getDollarFormat(item.cogs)}</h3>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                                              <label>Adjustments OUT</label>
                                              <h3 className="m-0">{getDollarFormat(item.adjustmentsOUT)}</h3>
                                            </div>

                                          </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
        }
    </div>
);}
export default Body;
